// extracted by mini-css-extract-plugin
export default {"button":"preview_button__9idmH","title":"preview_title__bnLUy","subtitle":"preview_subtitle__lVqTv","general_count":"preview_general_count__XZM3y"};